import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AnnouncementBar } from "./AnnouncementBar";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { MobileNav } from "./MobileNav";
import { CartDrawer } from "./CartDrawer";
import { AgeVerifyModal } from "./AgeVerifyModal";
import { Toaster } from "./ui/sonner";

export function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-brand-cream">
      <AnnouncementBar />
      <Header />
      <main className="flex-1 pb-20 md:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileNav />
      <CartDrawer />
      <AgeVerifyModal />
      <Toaster position="bottom-right" toastOptions={{ style: { background: "#153A26", color: "#F9F6F0", border: "1px solid #DCA54C55" } }} />
    </div>
  );
}
